import {NgModule} from "@angular/core"
import {RouterModule, Routes} from "@angular/router"
import {LoginPageComponent} from "app/login/view/LoginPageComponent"
import {environment} from "environments/environment"
import {AuthenticationGuard} from "app/common/services/auth/AuthenticationGuard"

const routes: Routes = [
    {
        path: "login",
        pathMatch: "full",
        component: LoginPageComponent,
        data: {
            public: true
        }
    },
    {
        path: "tradefloor",
        pathMatch: 'full',
        redirectTo: '/'
    },
    {
        path: "",
        loadChildren: "app/shell/ShellModule#ShellModule",
        canActivate: [AuthenticationGuard],
        canActivateChild: [AuthenticationGuard],
        canLoad: [AuthenticationGuard]
    }
]

@NgModule({
    imports: [RouterModule.forRoot(routes, {enableTracing: !environment.production, useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {

}
